export const PERMISSION_VIEW_TOURS = 'VT_ViewTours';
export const PERMISSION_CREATE_TOUR = 'VT_CreateTour';
export const PERMISSION_UPDATE_TOUR = 'VT_UpdateTour';
export const PERMISSION_DELETE_TOUR = 'VT_DeleteTour';
export const PERMISSION_CONFIG_TOUR = 'VT_ConfigTour';
export const PERMISSION_PUBLISH_TOUR = 'VT_PublishTour';

export const PERMISSION_MERGE_TOURs = 'VT_MergeTours';

export const PERMISSION_VIEW_SCENES = 'VT_ViewScenes';
export const PERMISSION_CREATE_SCENE = 'VT_CreateScene';
export const PERMISSION_UPDATE_SCENE = 'VT_UpdateScene';
export const PERMISSION_DELETE_SCENE = 'VT_DeleteScene';

export const PERMISSION_VIEW_TOUR_GUIDES = 'VT_ViewTourGuides';
export const PERMISSION_CREATE_TOUR_GUIDE = 'VT_CreateTourGuide';
export const PERMISSION_UPDATE_TOUR_GUIDE = 'VT_UpdateTourGuide';
export const PERMISSION_DELETE_TOUR_GUIDE = 'VT_DeleteTourGuide';

export const PERMISSION_VIEW_THEMES = 'VT_ViewThemes';
export const PERMISSION_CREATE_THEME = 'VT_CreateTheme';
export const PERMISSION_UPDATE_THEME = 'VT_UpdateTheme';
export const PERMISSION_DELETE_THEME = 'VT_DeleteTheme';

export const PERMISSION_VIEW_SALE_CONTACTS = 'VT_ViewSaleContacts';
export const PERMISSION_CREATE_SALE_CONTACT = 'VT_CreateSaleContact';
export const PERMISSION_UPDATE_SALE_CONTACT = 'VT_UpdateSaleContact';
export const PERMISSION_DELETE_SALE_CONTACT = 'VT_DeleteSaleContact';

export const PERMISSION_VIEW_ITEM_INFOS = 'VT_ViewItemInfos';
export const PERMISSION_CREATE_ITEM_INFO = 'VT_CreateItemInfo';
export const PERMISSION_UPDATE_ITEM_INFO = 'VT_UpdateItemInfo';
export const PERMISSION_DELETE_ITEM_INFO = 'VT_DeleteItemInfo';

export const PERMISSION_CONFIG_CATEGOIES = 'VT_ConfigTourCategories';
export const PERMISSION_CONFIG_GROUP_SCENE = 'VT_ConfigSceneGroup';
export const PERMISSION_CONFIG_FLOORPLAN = 'VT_ConfigTourFloorplan';
export const PERMISSION_CONFIG_THEME = 'VT_ConfigTourTheme';
export const PERMISSION_CONFIG_CONTACT = 'VT_ConfigTourContact';
export const PERMISSION_CONFIG_TOUR_GUIDE = 'VT_ConfigTourGuide';
export const PERMISSION_CONFIG_BACKGROUND_SOUND = 'VT_ConfigTourBackgroundSound';
export const PERMISSION_CONFIGURE_SCENARIO = 'VT_ConfigureScenario';
export const PERMISSION_CONFIGURE_BLEND_MODE = 'VT_ConfigureBlendMode';

export const PERMISSION_VIEW_PROMOTIONS = 'VT_ViewPromotions';
export const PERMISSION_CREATE_PROMOTION = 'VT_CreatePromotion';
export const PERMISSION_UPDATE_PROMOTION = 'VT_UpdatePromotion';
export const PERMISSION_DELETE_PROMOTION = 'VT_DeletePromotion';

export const PERMISSION_CREATE_PUBLIC_ICON_TEMPLATE = 'VT_CreatePublicIconTemplate';

export const PERMISSION_VIEW_USER_CONTACTS = 'CMS_ViewUserContacts';
export const PERMISSION_CREATE_USER_CONTACT = 'CMS_CreateUserContact';
export const PERMISSION_UPDATE_USER_CONTACT = 'CMS_UpdateUserContact';
export const PERMISSION_DELETE_USER_CONTACT = 'CMS_DeleteUserContact';

export const PERMISSION_VIEW_ASSIGNED_USER_CONTACTS = 'CMS_ViewAssignedUserContacts';
export const PERMISSION_CREATE_ASSIGNED_USER_CONTACT = 'CMS_CreateAssignedUserContact';

export const PERMISSION_VIEW_ALL_TOURS = 'VT_ViewAllTours';
export const PERMISSION_VIEW_ALL_SCENES = 'VT_ViewAllScenes';

export const PERMISSION_VIEW_WEB_ROTATE = 'CMS_ViewLayout360';
export const PERMISSION_CREATE_WEB_ROTATE = 'CMS_CreateLayout360';
export const PERMISSION_UPDATE_WEB_ROTATE = 'CMS_UpdateLayout360';
export const PERMISSION_DELETE_WEB_ROTATE = 'CMS_DeleteLayout360';

export const PERMISSION_VIEW_DRAFT_TOURS = 'VT_ViewDraftTours';
export const PERMISSION_CREATE_DRAFT_TOUR = 'VT_CreateDraftTour';
export const PERMISSION_UPDATE_DRAFT_TOUR = 'VT_UpdateDraftTour';
export const PERMISSION_DELETE_DRAFT_TOUR = 'VT_DeleteDraftTour';
export const PERMISSION_CONFIG_DRAFT_TOUR_FLOORPLAN = 'VT_ConfigDraftTourFloorplan';
export const PERMISSION_UPLOAD_DRAFT_TOUR_IMAGES = 'VT_UploadDraftTourImages';
export const PERMISSION_VIEW_SCANNABLE_DRAFT_TOURS = 'VT_ViewScannableDraftTours';
export const PERMISSION_SCAN_DRAFT_TOUR = 'VT_ScanDraftTour';
export const PERMISSION_PUBLISH_DRAFT_TOUR = 'VT_PublishDraftTour';

export const PERMISSION_CONFIG_LIVE_GUIDED_TOUR = 'VT_ConfigLiveGuidedTour';

export const PERMISSION_GENERATE_SUBTITLE = 'VT_GenerateSubtitle';

export const PERMISSION_UPLOAD_LOGO_SPLASH_SCREEN = 'VT_UploadLogoSplashScreen';
export const PERMISSION_CONFIG_CHATBOT = 'VT_ConfigChatbot';
export const PERMISSION_CONFIG_POI_TEMPLATE = 'VT_ConfigPoiTemplate';
